import { render, staticRenderFns } from "./AutomaticModeFeature.vue?vue&type=template&id=70c2e8e9&scoped=true&"
import script from "./AutomaticModeFeature.vue?vue&type=script&lang=js&"
export * from "./AutomaticModeFeature.vue?vue&type=script&lang=js&"
import style0 from "./AutomaticModeFeature.vue?vue&type=style&index=0&id=70c2e8e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c2e8e9",
  null
  
)

export default component.exports